// app/javascript/packs/drawing.js (Webpack/Webpackerを使用している場合)
// または app/javascript/drawings/draw.js (Import Mapsを使用している場合)
import Rails from '@rails/ujs'; 

document.addEventListener('DOMContentLoaded', () => {
    // Canvas要素とコンテキストの取得
    const bgCanvas = document.getElementById('bgCanvas');
    const drawCanvas = document.getElementById('drawCanvas');
    if (!bgCanvas) {
        console.warn("No bgCanvas found on this page. Skipping drawing module initialization.");
        return; 
    }
    const bgCtx = bgCanvas.getContext('2d');
    const ctx = drawCanvas.getContext('2d');

    // UIコントロール要素の取得
    const penButton = document.getElementById('penBtn');
    const eraserButton = document.getElementById('eraserBtn');
    const colorPicker = document.getElementById('colorPicker');
    const brushSizeInput = document.getElementById('brushSize');
    const undoButton = document.getElementById('undoBtn');
    const redoButton = document.getElementById('redoBtn');
    const clearButton = document.getElementById('clearBtn');
    const saveButton = document.getElementById('saveBtn');

    // HTMLのdata属性からメッセージとIDを取得
    const messages = {
        baseDiagramIdMissing: bgCanvas.dataset.msgBaseDiagramIdMissing,
        imageGenerationError: bgCanvas.dataset.msgImageGenerationError,
        securityError: bgCanvas.dataset.msgSecurityError,
        clearDrawingConfirm: bgCanvas.dataset.msgClearDrawingConfirm,
        saveSuccess: bgCanvas.dataset.msgSaveSuccess,
        saveFailure: bgCanvas.dataset.msgSaveFailure,
        ajaxError: bgCanvas.dataset.msgAjaxError
    };
    const initialDiagramId = bgCanvas.dataset.initialDiagramId;
    const treatmentId = bgCanvas.dataset.treatmentId;
    const shopId = bgCanvas.dataset.shopId;
    const treatmentShowUrl = bgCanvas.dataset.treatmentShowUrl; 
    // ★追加: data-save-drawing-url 属性を取得
    const saveDrawingUrl = bgCanvas.dataset.saveDrawingUrl; 

    // 描画状態に関する変数
    let drawing = false;
    let hasDrawn = false; // 実際に描画が行われたかを示すフラグ
    let erasing = false; // 消しゴムモードかどうかのフラグ
    let lastX = 0, lastY = 0; // 前回の描画座標

    // ブラシ設定
    let brushColor = colorPicker.value; // 初期ペン色
    let brushSize = parseInt(brushSizeInput.value, 10); // 初期ブラシサイズ

    // Undo/Redoスタック
    const undoStack = [];
    const redoStack = [];
    const MAX_UNDO_STATES = 50; // Undo履歴の最大数

    // 背景画像のロードと既存の描画データの読み込み
    let backgroundImage = new Image();
    backgroundImage.crossOrigin = "anonymous"; // クロスオリジン画像を扱うための設定

    // HTMLのdata属性から背景画像のURLと既存の描画データのURLを取得
    const initialBackgroundImageUrl = bgCanvas.dataset.backgroundUrl;
    const existingDrawingDataUrl = drawCanvas.dataset.existingDrawingDataUrl; 

    // 背景画像ロード成功時の処理
    backgroundImage.onload = () => {
        console.log("Background image loaded successfully.");
        // ★修正: アスペクト比を維持して背景Canvasに画像を描画
        drawBackground(backgroundImage); 
        
        // 既存の描画データがあればそれをロードし、なければ初期状態を保存
        if (existingDrawingDataUrl && existingDrawingDataUrl !== 'null' && existingDrawingDataUrl !== '') {
            console.log("Attempting to load existing drawing data...");
            restoreState(existingDrawingDataUrl); // 既存の描画データをロード
        } else {
            console.log("No existing drawing data found. Saving initial blank state.");
            saveState(); // 初期状態（背景画像がロードされ、描画Canvasは空）を保存
        }
    };

    // 背景画像ロード失敗時の処理
    backgroundImage.onerror = () => {
        console.error("Failed to load background image. Using fallback.", initialBackgroundImageUrl);
        // エラー時のフォールバックとしてダミー画像を設定
        // ※ picsum.photos は比較的安定していますが、完全にオフラインだとロードできません
        backgroundImage.src = 'https://picsum.photos/id/237/800/600'; 
        // フォールバック画像がロードされたら再度onloadが発火し、drawBackgroundとsaveState/restoreStateが実行される
    };

    // 背景画像のURLを設定（ロードを開始）
    // URLがない場合は、フォールバック用のダミー画像を設定
    backgroundImage.src = initialBackgroundImageUrl || 'https://picsum.photos/id/237/800/600';


    /**
     * 背景Canvasに画像を描画する (アスペクト比を維持して中央にフィット)
     * @param {Image} img - 描画するImageオブジェクト
     */
    function drawBackground(img) {
        const canvasWidth = bgCanvas.width;
        const canvasHeight = bgCanvas.height;
        bgCtx.clearRect(0, 0, canvasWidth, canvasHeight); // Canvasをクリア

        if (!img || !img.naturalWidth) {
            console.warn("Background image not available or not loaded for drawing.");
            return; // 画像が利用できない場合は描画しない
        }

        const imgAspectRatio = img.naturalWidth / img.naturalHeight;
        const canvasAspectRatio = canvasWidth / canvasHeight;

        let drawWidth, drawHeight;
        let offsetX = 0;
        let offsetY = 0;

        if (imgAspectRatio > canvasAspectRatio) {
            // 画像がキャンバスより横長の場合 (左右に余白ができる)
            drawWidth = canvasWidth;
            drawHeight = canvasWidth / imgAspectRatio;
            offsetY = (canvasHeight - drawHeight) / 2; // 上下中央揃え
        } else {
            // 画像がキャンバスより縦長、または同じアスペクト比の場合 (上下に余白ができる)
            drawHeight = canvasHeight;
            drawWidth = canvasHeight * imgAspectRatio;
            offsetX = (canvasWidth - drawWidth) / 2; // 左右中央揃え
        }
        
        bgCtx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
        console.log(`Background drawn: w=${drawWidth}, h=${drawHeight}, x=${offsetX}, y=${offsetY}`);
    }

    /**
     * 描画Canvasの現在の状態を保存し、Undoスタックに追加する
     */
    function saveState() {
        const currentState = drawCanvas.toDataURL();
        // 直前の状態と同じでなければ保存（重複防止）
        if (undoStack.length === 0 || undoStack[undoStack.length - 1] !== currentState) {
            undoStack.push(currentState);
            redoStack.length = 0; // 新しい操作でRedo履歴はクリア

            // Undo履歴の最大数を超えた場合、古い状態を削除
            if (undoStack.length > MAX_UNDO_STATES) {
                undoStack.shift();
            }
            console.log(`State Saved. Undo Stack Size: ${undoStack.length}, Redo Stack Size: ${redoStack.length}`);
        } else {
            console.log("State not changed, skipping save.");
        }
    }

    /**
     * 指定されたData URLの画像を描画Canvasに復元する
     * @param {string} dataUrl - 復元する画像のData URL
     */
    function restoreState(dataUrl) {
        const img = new Image();
        img.onload = () => {
            ctx.clearRect(0, 0, drawCanvas.width, drawCanvas.height); // 現在の描画をクリア
            ctx.drawImage(img, 0, 0); // 画像を描画Canvasに描画
            console.log(`State Restored. Undo Stack Size: ${undoStack.length}, Redo Stack Size: ${redoStack.length}`);
            
            // 既存描画ロード後も履歴の更新を許可
            // saveState()を呼び出すことで、ロードされた状態が最初のUndoステップとして保存される
            saveState(); 
        };
        img.onerror = () => {
            console.error("Failed to restore drawing state from Data URL:", dataUrl.substring(0, 50) + "..."); // URLが長いので一部表示
            // エラー時のフォールバック処理をここに追加することも可能
            saveState(); // 失敗しても空の状態で履歴を開始
        };
        img.src = dataUrl;
    }

    /**
     * 描画を開始する
     * @param {number} x - 開始X座標
     * @param {number} y - 開始Y座標
     */
    function startDrawing(x, y) {
        drawing = true;
        hasDrawn = false; // 新しい描画開始時にリセット
        lastX = x;
        lastY = y;
        ctx.beginPath(); // 新しいパスを開始
        ctx.moveTo(x, y); // 開始点へ移動
        
        // ブラシのスタイル設定
        ctx.lineWidth = brushSize;
        ctx.lineCap = 'round'; // 線の端を丸くする
        ctx.lineJoin = 'round'; // 線同士の接続を丸くする

        // 消しゴムモードの場合は合成モードを destination-out、ペンモードは source-over
        // ctx.strokeStyle は strokeStyle = 'transparent' として見えない線を描く必要はない
        // globalCompositeOperation がdestination-outの場合、strokeの色は描画に影響しない
        ctx.globalCompositeOperation = erasing ? 'destination-out' : 'source-over';
        // ペンモードの場合は色を設定
        if (!erasing) {
            ctx.strokeStyle = brushColor;
        }
        // 消しゴムモードの場合は、実際には描画される線の色は何でも良いが、
        // ユーザーには見えないようにするために色を設定しない、または透明色を設定する
        // 今回はglobalCompositeOperationに任せるため、strokeStyleは更新しない
    }

    /**
     * 描画を実行する（点を結ぶ）
     * @param {number} x - 現在のX座標
     * @param {number} y - 現在のY座標
     */
    function draw(x, y) {
        if (!drawing) return;
        // 実際に座標が少しでも動いて描画が行われた場合のみ hasDrawn をtrueにする
        if (Math.abs(x - lastX) > 0.5 || Math.abs(y - lastY) > 0.5) { 
            hasDrawn = true;
        }
        ctx.lineTo(x, y); // 現在の点まで線を描画
        ctx.stroke(); // 線を確定
        lastX = x; // 座標を更新
        lastY = y;
    }

    /**
     * 描画を終了する
     */
    function stopDrawing() {
        if (!drawing) return; // 既にdrawing=falseの場合は何もしない
        drawing = false;
        ctx.closePath(); // パスを閉じる
        // 実際に描画が行われた場合のみ状態を保存
        if (hasDrawn) {
            saveState();
        }
    }

    /**
     * マウスイベントからCanvas上の座標を取得する
     * @param {MouseEvent} evt - マウスイベントオブジェクト
     * @returns {{x: number, y: number}} Canvas上の座標
     */
    function getPos(evt) {
        const rect = drawCanvas.getBoundingClientRect();
        return {
            x: evt.clientX - rect.left,
            y: evt.clientY - rect.top
        };
    }

    /**
     * タッチイベントからCanvas上の座標を取得する
     * @param {TouchEvent.Touch} touch - タッチイベントのTouchオブジェクト
     * @returns {{x: number, y: number}} Canvas上の座標
     */
    function getTouchPos(touch) {
        const rect = drawCanvas.getBoundingClientRect();
        return {
            x: touch.clientX - rect.left,
            y: touch.clientY - rect.top
        };
    }

    /**
     * 背景画像と描画内容を統合してPNG画像としてサーバーに送信する
     */
    async function saveCombinedImage() {
        console.log('[SAVE] Save button clicked.');

        if (!initialDiagramId) {
            alert(messages.baseDiagramIdMissing); 
            console.warn('[SAVE] Base diagram ID is missing.');
            return;
        }

        let imageDataURL;
        try {
            const exportCanvasElement = document.createElement('canvas');
            exportCanvasElement.width = bgCanvas.width;
            exportCanvasElement.height = bgCanvas.height; 
            let exportContext = exportCanvasElement.getContext('2d');

            // 背景を描画 (注意: クロスオリジン画像の場合、ここで汚染される可能性があります)
            // drawBackground関数はbgCtxに描画するので、ここではbgCanvasの内容をコピー
            exportContext.drawImage(bgCanvas, 0, 0); 
            // 描画内容を重ねて描画
            exportContext.drawImage(drawCanvas, 0, 0);

            imageDataURL = exportCanvasElement.toDataURL('image/png'); 
            console.log('[SAVE] Combined image data URL generated.');

            exportCanvasElement.remove();
            exportContext = null;

        } catch (error) {
            console.error('[SAVE] Error generating combined image data URL:', error);
            if (error instanceof DOMException && error.name === "SecurityError") {
                console.error("CORS Error: The Canvas might be 'tainted' by cross-origin content.");
                alert(messages.securityError); 
            } else {
                console.error("Unknown error during image generation:", error.message);
                alert(messages.imageGenerationError); 
            }
            return;
        }

        const drawingForReEdit = drawCanvas.toDataURL(); 

        // ★ここを修正: data-save-drawing-url 属性を参照
        const url = saveDrawingUrl || `/shops/${shopId}/treatments/${treatmentId}/save_drawing`;
        console.log('[SAVE] Sending drawing data to:', url);

        const blob = await fetch(imageDataURL).then(res => res.blob());

        const formData = new FormData();
        formData.append('image_data', blob, 'drawing.png');
        formData.append('base_diagram_id', initialDiagramId);
        formData.append('drawing_for_re_edit_data', drawingForReEdit);
        formData.append('authenticity_token', Rails.csrfToken());

        Rails.ajax({
            url: url,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: (data) => {
                console.log('[SAVE] Save success response:', data);
                if (data.status === 'success') {
                    // alert(messages.saveSuccess); 
                    // data-treatment-show-url 属性を参照
                    if (treatmentShowUrl) {
                        window.location.href = treatmentShowUrl;
                    } else {
                        // フォールバック: もし属性が設定されていなければ、以前のURLを構築
                        window.location.href = `/shops/${shopId}/treatments/${treatmentId}`;
                    }
                } else {
                    alert(messages.saveFailure + (data.message || '')); // data.message がない場合を考慮
                }
            },
            error: (xhr, status, error) => {
                console.error('[SAVE] Ajax error:', xhr, status, error);
                const errorMessage = xhr.responseJSON && xhr.responseJSON.message ? 
                                     xhr.responseJSON.message : 
                                     (error && error.message) || '不明なエラー'; // errorオブジェクトからメッセージ取得
                alert(messages.ajaxError + errorMessage); 
            }
        });
    }

    // --- イベントリスナーの登録 ---

    // マウスイベント
    drawCanvas.addEventListener('mousedown', e => {
        const { x, y } = getPos(e);
        startDrawing(x, y);
    });
    drawCanvas.addEventListener('mousemove', e => {
        const { x, y } = getPos(e);
        draw(x, y);
    });
    drawCanvas.addEventListener('mouseup', stopDrawing);
    drawCanvas.addEventListener('mouseleave', stopDrawing);

    // タッチイベント
    drawCanvas.addEventListener('touchstart', e => {
        e.preventDefault(); // デフォルトのスクロールなどを防止
        const touch = e.touches[0];
        const { x, y } = getTouchPos(touch);
        startDrawing(x, y);
    }, { passive: false }); // passive: false で preventDefault() を有効にする
    drawCanvas.addEventListener('touchmove', e => {
        e.preventDefault(); // デフォルトのスクロールなどを防止
        const touch = e.touches[0];
        const { x, y } = getTouchPos(touch);
        draw(x, y);
    }, { passive: false });
    drawCanvas.addEventListener('touchend', e => {
        e.preventDefault(); // デフォルトのスクロールなどを防止
        stopDrawing();
    }, { passive: false });

    // UI コントロール
    penButton.addEventListener('click', () => {
        erasing = false;
        // ペンモードに切り替わったことをユーザーに視覚的に示すCSSクラスなどを適用すると良いでしょう
        // 例: penButton.classList.add('active'); eraserButton.classList.remove('active');
    });

    eraserButton.addEventListener('click', () => {
        erasing = true;
        // 消しゴムモードに切り替わったことをユーザーに視覚的に示すCSSクラスなどを適用すると良いでしょう
    });

    colorPicker.addEventListener('input', (e) => {
        brushColor = e.target.value;
        erasing = false; // 色変更時は自動的にペンモードに切り替え
        // penButton.click(); // これを使うとイベントが二重に発火する可能性があるので、直接 erasing = false; で良い
        // 必要に応じてペンボタンの見た目をアクティブにする処理などを追加
    });

    brushSizeInput.addEventListener('input', (e) => {
        brushSize = parseInt(e.target.value, 10);
    });

    undoButton.addEventListener('click', () => {
        if (undoStack.length > 1) { // 最初の背景状態（Undoスタックの0番目）より前の状態に戻らない
            const currentState = undoStack.pop();
            redoStack.push(currentState);
            const prevData = undoStack[undoStack.length - 1];
            restoreState(prevData);
        } else if (undoStack.length === 1) { // スタックに初期状態しかない場合
            const currentState = undoStack.pop();
            redoStack.push(currentState);
            ctx.clearRect(0, 0, drawCanvas.width, drawCanvas.height); // drawCanvasを完全にクリア
            console.log(`State Restored to initial blank. Undo Stack Size: ${undoStack.length}, Redo Stack Size: ${redoStack.length}`);
        } else {
            console.log("Undo stack is empty, cannot undo.");
        }
    });

    redoButton.addEventListener('click', () => {
        if (redoStack.length > 0) {
            // 現在のキャンバス状態をUndoスタックに保存してからRedoする
            const currentCanvasState = drawCanvas.toDataURL();
            undoStack.push(currentCanvasState); 

            const nextData = redoStack.pop();
            restoreState(nextData);
        } else {
            console.log("Redo stack is empty, cannot redo.");
        }
    });

    clearButton.addEventListener('click', () => {
        // I18nメッセージを使用
        if (confirm(messages.clearDrawingConfirm)) {
            ctx.clearRect(0, 0, drawCanvas.width, drawCanvas.height);
            undoStack.length = 0; // Undo履歴をクリア
            redoStack.length = 0; // Redo履歴をクリア
            saveState(); // クリア後の状態を最初の状態として保存
        }
    });

    saveButton.addEventListener('click', saveCombinedImage); // すでに定義済み

    // 初期Canvas設定 (drawCanvasのコンテキストに適用)
    ctx.lineWidth = brushSize;
    ctx.strokeStyle = brushColor;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.globalCompositeOperation = 'source-over'; // 初期はペンモード

    // 初回描画のためにdrawBackgroundを呼び出す（backgroundImage.onloadでも呼び出されるが、念のため）
    // backgroundImage.src が設定された後にloadImageToCanvasが呼ばれるため、ここでは不要
    // しかし、即座に背景が表示されない場合は、初期状態を明示的に描画しても良い
    // 例: if (backgroundImage.complete) { drawBackground(backgroundImage); }

});